import ticketsApi from 'api/requests/tickets';
import Icon from 'components/_UI/Icon';
import Loader from 'components/_UI/Loader';
import Progress from 'components/_UI/Progress';
import Text from 'components/_UI/Text';
import currency from 'helpers/currency';
import ProductCard from 'modules/dashboard/products/list/ProductCard';
import React, { useEffect, useState } from 'react'
import { Calendar } from 'lucide-react';
import styled from 'styled-components';
import { BlockContent } from 'styled/UI/BlockContent';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import fonts from 'theme/fonts';

export default function ProductDetail({ data }) {
    const [products, setProducts] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [productTotals, setProductTotal] = useState({});
    const [productPercentages, setProductPercentages] = useState({});
    const [amountTotal, setAmountTotal] = useState(0);
    const [percentageSold, setPercentageSold] = useState(0);
    const [percentageAvailable, setPercentageAvailable] = useState(0);
    const [soldAmountProduct, setSoldAmountProduct] = useState(0);
    const [productsRevenueTotal, setProductsRevenueTotal] = useState(0);
    const [productsRevenueSold, setProductsRevenueSold] = useState(0);

    useEffect(() => {

        getProducts(data)
    }, [])

    async function getProducts(slug) {
        setIsLoading(true)
        try {
            const { data } = await ticketsApi.getTicketForEvent(slug);
            setSoldAmountProduct(data?.products_sold)
            setAmountTotal(data?.products_total)
            setProducts(data?.products)
            setProductsRevenueTotal(data?.products_revenue_total)
            setProductsRevenueSold(data?.products_revenue_sold)
            setSoldAmountProduct(data?.products_sold);


            let totals = {};
            let percentages = {};

            data?.products?.forEach(product => {
                let totalCollected = 0;
                let totalEstimated = 0;
                let soldQuantity = 0;
                let totalQuantity = 0;

                product?.batches?.forEach(batch => {
                    soldQuantity += (batch.quantity - batch.quantity_available);
                    totalQuantity += batch.quantity;
                    totalCollected += batch?.value_sold_without_tax
                    totalEstimated += batch.quantity * batch.price;
                });

                totals[product.id] = {
                    collected: totalCollected,
                    estimated: totalEstimated
                };

                percentages[product.id] = (soldQuantity / totalQuantity) * 100;
            });

            setProductTotal(totals)
            setProductPercentages(percentages)

            const globalPercentageSold = data?.products_total > 0
                ? (data?.products_sold / data?.products_total) * 100
                : 0;

            setPercentageSold(globalPercentageSold);
            setPercentageAvailable(100 - globalPercentageSold);

        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }
    return (
        <>
            {
                isLoading ? (
                    <ContentLoader>
                        <Loader />
                    </ContentLoader>
                ) : (
                    <Column width='100%'>
                        <TicketsStatistics>
                            <StatisticCardItem type='sold'>
                                <Column>
                                    <Text color={colors.secondaryPurple} paddingBottom={'0'}>
                                        Ingressos vendidos
                                    </Text>
                                    <StyledProgressSale>
                                        <Row style={{ alignItems: 'flex-end' }}>
                                            <Text color={colors.secondaryPurple} name='hero' paddingBottom={0}>
                                                {soldAmountProduct}/
                                            </Text>
                                            <Text color={colors.secondaryPurple} name='title' paddingBottom={'8px'}>
                                                {amountTotal}
                                            </Text>
                                        </Row>
                                        <CircularIcon type='sold'>
                                            <Column width='20px' height='20px'>
                                                <Icon name='label' color={colors.neutralLight} />
                                            </Column>
                                        </CircularIcon>
                                    </StyledProgressSale>
                                </Column>

                                <Column marginTop='16px'>
                                    <Progress value={percentageSold.toFixed(2)} bgColor={'#E9D5FF'} color={colors.secondaryPurple} />
                                    <Text color={colors.secondaryPurple} marginTop={'6px'}>{percentageSold.toFixed(2)}% total</Text>
                                </Column>
                            </StatisticCardItem>

                            <StatisticCardItem type='toSell'>
                                <Column>
                                    <Text color={colors.success} paddingBottom={'0'}>
                                        Disponíveis
                                    </Text>
                                    <ContentTicketToSell>
                                        <Row style={{ alignItems: 'flex-end' }}>
                                            <Text color={colors.success} name='hero' paddingBottom={'0'}>
                                                {amountTotal - soldAmountProduct}/
                                            </Text>
                                            <Text color={colors.success} name='title' paddingBottom={'8px'}>
                                                {amountTotal}
                                            </Text>
                                        </Row>
                                        <CircularIcon type='toSell'>
                                            <Column width='24px' height='24px'>
                                                <Icon name='label' color={colors.neutralLight} />
                                            </Column>
                                        </CircularIcon>
                                    </ContentTicketToSell>
                                </Column>

                                <Column marginTop='16px'>
                                    <Progress value={percentageAvailable.toFixed(2)} bgColor={'#BBF7D0'} color={colors.success} />
                                    <Text marginTop={'6px'} color={colors.success}>{percentageAvailable.toFixed(2)}% disponivel</Text>
                                </Column>
                            </StatisticCardItem>

                            <StatisticCardItem type='general'>
                                <Column>
                                    <Text color={colors.primary} paddingBottom={'0'}>
                                        Receita total
                                    </Text>
                                    <ContentTicketToSell>
                                        <Column>
                                            <Text color={colors.primaryDark} paddingBottom={'0'} name='title'>
                                                {currency.format(productsRevenueSold)}
                                            </Text>
                                            <Text color={colors.primary} paddingBottom={'0'}>
                                                de {currency.format(productsRevenueTotal)}
                                            </Text>
                                        </Column>
                                        <CircularIcon type='general'>
                                            <Calendar color={colors.neutralLight} />
                                        </CircularIcon>
                                    </ContentTicketToSell>
                                </Column>

                                <Column marginTop='16px'>
                                    <Progress
                                        value={
                                            productsRevenueTotal > 0
                                                ? Math.round((productsRevenueSold / productsRevenueTotal) * 100)
                                                : 0
                                        }
                                        bgColor={'#BFDBFE'}
                                        color={colors.primary}
                                    />
                                    <Text color={colors.primary} marginTop={'6px'}>
                                        {productsRevenueTotal > 0
                                            ? `${Math.round((productsRevenueSold / productsRevenueTotal) * 100)}% da meta`
                                            : '0% da meta'}
                                    </Text>
                                </Column>
                            </StatisticCardItem>

                        </TicketsStatistics>

                        <Column>
                            <BlockContent>
                                <Text name='subtitle' color={colors.nightDark}>
                                    Estatísticas de vendas
                                </Text>

                                <Text color={colors.nightDark}>
                                    Confira a porcentagem de produtos vendidos para cada categoria e acompanhe seu desempenho.
                                </Text>


                                <ContainerProgressData>
                                    {products?.map((el) => (
                                        <ContentProgressData key={el.id}>
                                            <Row style={{ 'justifyContent': 'space-between' }}>
                                                <Text type='bold' color={colors.secondaryPurple}>{el?.name}</Text>
                                                <Text type='bold' color={colors.secondaryPurple} marginLeft={'10px'}>
                                                    {Math.round(productPercentages[el.id])}%
                                                </Text>
                                            </Row>
                                            <Progress value={productPercentages[el.id]} bgColor={'#ccc'} color={colors.occasionalPurple} />
                                        </ContentProgressData>
                                    ))}
                                </ContainerProgressData>
                            </BlockContent>


                            <ContainerProducts>
                                <BlockContent>
                                    <Column>
                                        <Text name='subtitle' color={colors.nightDark}>Produtos disponíveis</Text>
                                        <Text color={colors.night}>Gerencie todos os produtos do seu evento e acompanhe as vendas.</Text>
                                    </Column>

                                    <StyledTitles>
                                        <ContentTitles products>
                                            <Text color={colors.nightDark} type='bold'>Produtos</Text>
                                        </ContentTitles>
                                        <ContentTitles>
                                            <Text color={colors.nightDark} type='bold'>Valor arrecadado (sem taxas)</Text>
                                        </ContentTitles>
                                        <ContentTitles>
                                            <Text color={colors.nightDark} type='bold'>Valor estimado</Text>
                                        </ContentTitles>
                                    </StyledTitles>

                                    {
                                        products?.map((el) => (
                                            <ProductsList key={el.id}>
                                                <Row>
                                                    <ContentProducts>
                                                        <ProductCard data={el} dropDownVisible={false} isVisiblePrice />
                                                    </ContentProducts>
                                                </Row>

                                                <ContentValues>

                                                    <ProductsValues>
                                                        <StyledValues collected>
                                                            <TextTitlesValues>
                                                                <Text color={colors.night}>Valor arrecadado (sem taxas)</Text>
                                                            </TextTitlesValues>
                                                            <Text color={colors.night}>{currency.format(productTotals[el.id]?.collected || 0)}</Text>
                                                        </StyledValues>
                                                    </ProductsValues>

                                                    <ProductsValues>
                                                        <StyledValues>
                                                            <TextTitlesValues>
                                                                <Text color={colors.night}>Valor estimado</Text>
                                                            </TextTitlesValues>
                                                            <Text color={colors.night}>{currency.format(productTotals[el.id]?.estimated || 0)}</Text>
                                                        </StyledValues>
                                                    </ProductsValues>
                                                </ContentValues>

                                            </ProductsList>
                                        ))
                                    }
                                </BlockContent>
                            </ContainerProducts>

                        </Column>
                    </Column>
                )
            }
        </>
    )
}

const StyledData = styled(Column)`
    margin-top: 30px;
    width: 100%;

    & > div > div > div > h1 {
        display: flex;
        align-items: center;
    }
`;

const ContentData = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
`;


const StyledTotals = styled(Column)`
    width: 100%;

    @media screen and (min-width: ${breakpoints.sm}) {
        width: 50%;
    }
`

const StyledProgressSale = styled.div`
    display: flex;
    flex-direction: row;
`;

const ContentTicketToSell = styled.div`
    display: flex;
    flex-direction: row;
`;


const ContainerProgressData = styled.div`
    /* margin-top: 15px; */
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    @media screen and (min-width: ${breakpoints.sm}) {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
`;

const ContainerProducts = styled.div`
    display: flex;
    flex-direction: column;
    /* margin-top: 20px; */
    /* margin-bottom: 20px; */
`;


const ContentProgressData = styled.div`
    width: 100%;
     margin-top: 24px;

    &:first-child {
        margin-top: 0;
    }
    @media screen and (min-width: ${breakpoints.sm}) {
        /* width: 220px; */
        /* margin-top: 0; */
        margin-right: 20px;
    }
`;

const ProductsList = styled(Column)`
    border-bottom: 2px solid ${colors.nightLight};
    margin-top: 25px;
    
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        border-bottom: unset;
    }
`;

const ContentProducts = styled(Row)`
    width: 100%;
    padding-right: 20px;

    & > div {
        @media screen and (min-width: ${breakpoints.xm}) and (max-width: 375px) {
            width: 100%;
        }

        @media screen and (min-width: ${breakpoints.sm}) {
            width: 60%;
            padding-right: 20px;
            
        }
        @media screen and (min-width: ${breakpoints.lg}) {
            width: 100%;
        }
        @media screen and (min-width: ${breakpoints.xl}) {
            padding-right: 20px;
        }
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        border-right: 1px solid ${colors.nightLight};
    }
    


`;


const ContentValues = styled(Row)`
    justify-content: center;
`;

const ProductsValues = styled(Row)`
    margin-top: 20px;
    justify-content: space-around;
    padding-bottom: 20px;
    @media screen and (min-width: ${breakpoints.lg}) {
        padding-bottom: unset;
        margin: unset;
    }
    width: 40%;
`;


const StyledValues = styled(Column)`
    justify-content: center;
    margin-top: 20px;
    align-items: center;
    @media screen and (min-width: ${breakpoints.lg}) {
        align-items: flex-start;
        padding-left: 30px;
    }
    ${({ collected }) => collected && `
        border-right: 1px solid ${colors.nightLight};
        @media screen and (min-width: ${breakpoints.md}) {
            padding-left: 0px;
            // background: red;
            border-right: 1px solid ${colors.nightLight};
        }
    `}
    @media screen and (min-width: ${breakpoints.lg}) {
        margin: unset;
    }
`;

const TextTitlesValues = styled.div`
    display: flex;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: none;
    }
`;

const StyledTitles = styled(Row)`
    display: none;
    width: 100%;
    @media screen and (min-width: ${breakpoints.lg}) {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
    }
`;


const ContentTitles = styled(Row)`
    justify-content: flex-start;
   
    & > p {
        font-size: ${fonts.sizes.highlight};
        color: ${colors.night}
    }

    @media screen and (min-width: ${breakpoints.md}) {
        width: 25%;
    }

    ${({ products }) => products && `
        justify-content: flex-start;
        margin-left: 10px;

        @media screen and (min-width: ${breakpoints.md}) {
            width: 50%;
            
        }
    `}

`;

const ContentLoader = styled(Column)`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TicketsStatistics = styled(Column)`
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 12px;
    }
`

const StatisticCardItem = styled(Column)`
    margin-bottom: 14px;
    width: 100%;
    padding: 14px;
    justify-content: space-between;

    @media screen and (min-width: ${breakpoints.lg}) {
        width: 32.5%;
    }

    ${({ type }) => type == 'sold' && `
        background-color: #F7EFFF;
        border: 1px solid ${colors.secondaryPurple};
        border-radius: 8px;
    `};
    
    ${({ type }) => type == 'toSell' && `
        border: 1px solid ${colors.success};
        border-radius: 8px;
        `};

    ${({ type }) => type == 'general' && `
        background-color: #E6F1FE;
        border: 1px solid ${colors.primary};
        border-radius: 8px;
    `};
    
`

const CircularIcon = styled(FullyCentered)`
    border-radius: 30px;
    width: 50px;
    padding: 8px;

    ${({ type }) => type == 'sold' && `
        background-color: ${colors.secondaryPurple};
    `};
    
    ${({ type }) => type == 'toSell' && `
        background-color: ${colors.success};
    `};

    ${({ type }) => type == 'general' && `
        background-color: ${colors.primary};
    `};
  `;
